var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.922 99.599C51.352 99.599 50.827 99.366 50.445 98.941C49.079 97.42 16.981 61.416 16.981 37.092C16.981 17.825 32.655 2.151 51.921 2.151C71.187 2.151 86.8599 17.825 86.8609 37.092C86.8609 61.415 54.763 97.42 53.397 98.941C53.023 99.358 52.485 99.599 51.922 99.599ZM51.922 6.122C34.845 6.122 20.951 20.015 20.951 37.092C20.951 56.318 43.91 85.083 50.946 93.442L51.922 94.6L52.8979 93.442C59.9339 85.083 82.892 56.315 82.893 37.092C82.893 20.015 68.999 6.122 51.922 6.122Z",
    fill: "#0059F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.922 54.036C42.579 54.036 34.978 46.435 34.978 37.092C34.978 27.749 42.58 20.147 51.922 20.147C61.264 20.147 68.866 27.749 68.866 37.092C68.866 46.435 61.265 54.036 51.922 54.036ZM51.922 24.117C44.768 24.117 38.946 29.938 38.946 37.092C38.946 44.246 44.767 50.067 51.922 50.067C59.077 50.067 64.898 44.246 64.898 37.092C64.898 29.938 59.076 24.117 51.922 24.117Z",
    fill: "#0059F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.917e7f82bdc540bb93b4222e30b8e888.svg";
export { ForwardRef as ReactComponent };